import { render, staticRenderFns } from "./DeleteInspectionRoute.vue?vue&type=template&id=3c8f2d34"
import script from "./DeleteInspectionRoute.vue?vue&type=script&lang=js"
export * from "./DeleteInspectionRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports